(function (angular) {
    'use strict';

    angular.module('whatsApp')
        /**
         *
         */
        .controller('whatsAppHsmController',
        ['$scope', 'hsmsData', '$uibModalInstance',
            function ($scope, hsmsData, $uibModalInstance) {
                $scope.hsms = hsmsData;
                $scope.picked = {};
                $scope.pickHsm = function(hsm){
                    $scope.picked.hsm = hsm;
                    $scope.languageCodes = Object.keys(hsm.messages);
                    $scope.picked.languageCode = $scope.languageCodes[0];
                }
                $scope.close = function(){
                    $uibModalInstance.dismiss('cancel');
                };
        }]);


})(window.angular);